import { getUnreadMessagesRequestAsync } from 'features/ChatList/api'
import { AppThunk } from '../../type'
import { setTotalUnreadMessages } from './slice'

export const getUnreadMessagesActionAsync =
  (): AppThunk => async (dispatch) => {
    const { data } = await getUnreadMessagesRequestAsync()
    if (data) {
      dispatch(setTotalUnreadMessages(data.unread_count))
    }
  }
